var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "adb287f3-30ac-43c9-a735-43eb79c1db1b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 778.1179 179.4774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e68434e3-a94e-442e-9a27-3776a8b2cb17",
    transform: "translate(-147.7442 -450.2613)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080,
    style: {
      fill: "none"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "enc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "328.09 52.647 368.295 92.852 368.295 52.647 380.153 52.647 380.153 118.127 337.822 78.159 337.822 118.127 328.09 118.127 328.09 52.647",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.09 52.647 368.295 92.852 368.295 52.647 380.153 52.647 380.153 118.127 337.822 78.159 337.822 118.127 328.09 118.127 328.09 52.647",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#e68434e3-a94e-442e-9a27-3776a8b2cb17)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.9292,535.5068a41.6824,41.6824,0,0,0,6.166,21.897c10.283,16.709,37.821,11.425,39.684.623l-5.622-7.78s-3.094,5.103-11.811,5.103a14.7589,14.7589,0,0,1-12.4721-6.166,25.1763,25.1763,0,0,1,0-27.354,14.7589,14.7589,0,0,1,12.4721-6.166c8.717,0,11.811,5.103,11.811,5.103l5.622-7.78c-1.863-10.802-29.401-16.087-39.684.622a41.6881,41.6881,0,0,0-6.166,21.898",
    transform: "translate(-147.7442 -450.2613)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.9292,535.5068a41.6824,41.6824,0,0,0,6.166,21.897c10.283,16.709,37.821,11.425,39.684.623l-5.622-7.78s-3.094,5.103-11.811,5.103a14.7589,14.7589,0,0,1-12.4721-6.166,25.1763,25.1763,0,0,1,0-27.354,14.7589,14.7589,0,0,1,12.4721-6.166c8.717,0,11.811,5.103,11.811,5.103l5.622-7.78c-1.863-10.802-29.401-16.087-39.684.622A41.6881,41.6881,0,0,0,538.9292,535.5068Z",
    transform: "translate(-147.7442 -450.2613)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.1908,542.9332c9.869,0,8.269-17.51,8.269-17.51,0-21.39-15.71-21.39-15.71-21.39H595.34v63.07h14.68v-19.02l8.99-.15,11.88,19.17h13.88Zm-7.141-8.79-13.03.15v-17.75h12.51c.11,0,4.57.06,4.57,9.51,0,0,.06,8.09-4.05,8.09",
    transform: "translate(-147.7442 -450.2613)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.1908,542.9332c9.869,0,8.269-17.51,8.269-17.51,0-21.39-15.71-21.39-15.71-21.39H595.34v63.07h14.68v-19.02l8.99-.15,11.88,19.17h13.88Zm-7.141-8.79-13.03.15v-17.75h12.51c.11,0,4.57.06,4.57,9.51C627.1,526.0532,627.16,534.1431,623.05,534.1431Z",
    transform: "translate(-147.7442 -450.2613)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "530.814 94.272 553.066 54.05 539.517 53.945 524.056 81.852 508.594 53.892 495.045 53.997 517.3 94.246 517.3 117.224 530.817 117.224 530.814 94.272",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "530.814 94.272 553.066 54.05 539.517 53.945 524.056 81.852 508.594 53.892 495.045 53.997 517.3 94.246 517.3 117.224 530.817 117.224 530.814 94.272",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.63,504.153l-22.25-.12v63.45h12.901V545.8541l11.8991-.1411c15.58,0,15.59-20.24,15.59-20.29,0-21.57-18.14-21.27-18.14-21.27m-1.7,30.43h-7.6491V517.459h7.29s8.009.7341,8.009,8.124c0,8.99-7.62,9-7.65,9",
    transform: "translate(-147.7442 -450.2613)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.63,504.153l-22.25-.12v63.45h12.901V545.8541l11.8991-.1411c15.58,0,15.59-20.24,15.59-20.29C747.77,503.853,729.63,504.153,729.63,504.153Zm-1.7,30.43h-7.6491V517.459h7.29s8.009.7341,8.009,8.124C735.58,534.5731,727.96,534.583,727.93,534.583Z",
    transform: "translate(-147.7442 -450.2613)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.06,497.0532v54.7091c0,6.141,2.511,5.591,2.511,5.591H797.17v5.3c0,5.3589-5.65,4.83-5.65,4.83h-12.279c-11.91,0-12.29-12.61-12.29-12.61v-57.82H448.15v39.78c0,8.2-13.31,15.65-14.35,15.96l-9.46.5-2.62-11.34c10.91,0,12.26-10.41,12.26-10.41v-34.49h-36.1s.38,40.53.38,48.56c0,7.18,48.571,34.1089,48.571,34.1089s3.299.851,3.299,14.081-6.989,17.77-6.989,17.77-13.081.37-10.201-6.05c0,0,6.61-14.08,3.681-17.011-2.641-2.639-50.641-28.629-50.641-40.629v-50.83H352.06v-11.29h414.891s1.229-17.34,9.6389-17.34h5.47v17.34h25.8109v11.29Z",
    transform: "translate(-147.7442 -450.2613)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.06,497.0532v54.7091c0,6.141,2.511,5.591,2.511,5.591H797.17v5.3c0,5.3589-5.65,4.83-5.65,4.83h-12.279c-11.91,0-12.29-12.61-12.29-12.61v-57.82H448.15v39.78c0,8.2-13.31,15.65-14.35,15.96l-9.46.5-2.62-11.34c10.91,0,12.26-10.41,12.26-10.41v-34.49h-36.1s.38,40.53.38,48.56c0,7.18,48.571,34.1089,48.571,34.1089s3.299.851,3.299,14.081-6.989,17.77-6.989,17.77-13.081.37-10.201-6.05c0,0,6.61-14.08,3.681-17.011-2.641-2.639-50.641-28.629-50.641-40.629v-50.83H352.06v-11.29h414.891s1.229-17.34,9.6389-17.34h5.47v17.34h25.8109v11.29Z",
    transform: "translate(-147.7442 -450.2613)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.0391,493.2705l5.103,7.7481a18.5413,18.5413,0,0,1,13.488-5.7281c8.645,0,9.343,5.964,9.531,9.0351.19,3.0709.981,10.9129-14.279,10.9129v9.685s16.653-2.74,17.339,12.0951c0,0,1.7,10.7719-10.961,10.7719s-25.831-21.815-25.831-29.1859l-10.24,3.4729s8.48,37.996,34.559,37.996,24.756-19.976,21.496-27.799h16.725v36.681H877.74v-70.158h23.103v70.158h10.771V498.6566h13.748v-12.331h-68.031v12.4249h10.252v22.866h-24s6.519-4.501,6.519-17.4629-8.787-19.5291-18.992-19.5291-16.346,2.0321-21.071,8.646",
    transform: "translate(-147.7442 -450.2613)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.0391,493.2705l5.103,7.7481a18.5413,18.5413,0,0,1,13.488-5.7281c8.645,0,9.343,5.964,9.531,9.0351.19,3.0709.981,10.9129-14.279,10.9129v9.685s16.653-2.74,17.339,12.0951c0,0,1.7,10.7719-10.961,10.7719s-25.831-21.815-25.831-29.1859l-10.24,3.4729s8.48,37.996,34.559,37.996,24.756-19.976,21.496-27.799h16.725v36.681H877.74v-70.158h23.103v70.158h10.771V498.6566h13.748v-12.331h-68.031v12.4249h10.252v22.866h-24s6.519-4.501,6.519-17.4629-8.787-19.5291-18.992-19.5291S814.7641,486.6566,810.0391,493.2705Z",
    transform: "translate(-147.7442 -450.2613)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.7119,478.7642a85.6416,85.6416,0,0,1,22.646,38.249,84.422,84.422,0,0,1-7.978,64.426,87.84,87.84,0,0,1-19.482,23.468c-5.91,5.022-25.983,21.556-56.233,21.696-31.735.147-52.815-17.849-58.448-23.025-4.189-3.85-28.421-26.878-28.338-63.76.104-45.857,37.701-70.95,40.293-72.6159,24.646-15.836,49.916-14.156,58.005-13.284",
    transform: "translate(-147.7442 -450.2613)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "6.269000053405762px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.8047,499.5249q.996,6.753,1.992,13.505l29.224-4.428a70.7821,70.7821,0,0,0-5.756,11.955,71.7024,71.7024,0,0,0-3.985,16.826c-.691,6.139-1.827,16.234,2.213,27.452,3.161,8.774,8.045,14.232,12.841,19.482,9.531,10.436,19.116,15.776,28.338,20.811a136.8124,136.8124,0,0,0,40.293,14.612,112.4387,112.4387,0,0,0,22.139,1.328c7.028-.233,12.856-1.073,18.154-4.871a23.5925,23.5925,0,0,0,2.657-2.214q-5.9775-4.4265-11.955-8.855a15.0581,15.0581,0,0,1-11.512,7.527,79.0175,79.0175,0,0,1-17.269.444,88.7482,88.7482,0,0,1-22.582-5.314,121.09,121.09,0,0,1-32.765-18.154,40.9176,40.9176,0,0,1-5.756-5.756c-1.04-1.275-2.169-2.916-4.428-6.199-1.53-2.224-2.295-3.335-2.657-3.985a24.5556,24.5556,0,0,1-2.657-8.4129,92.9976,92.9976,0,0,1-1.328-14.1691,103.25,103.25,0,0,1,2.214-20.811,83.4093,83.4093,0,0,1,11.069-24.795q9.078-1.551,18.154-3.1a111.8119,111.8119,0,0,1,11.07,12.3979,30.1468,30.1468,0,0,1,3.542,5.756,31.3618,31.3618,0,0,1,2.214,7.085,25.8566,25.8566,0,0,1,.443,10.184,21.0332,21.0332,0,0,1-17.711,17.268,10.6671,10.6671,0,0,1-2.657,0c-4.625-.5869-7.507-4.103-8.413-5.314q-1.3275,1.3292-2.657,2.658a28.4528,28.4528,0,0,0,6.199,7.527,28.1326,28.1326,0,0,0,9.299,5.3131,27.6326,27.6326,0,0,0,11.069,1.3289,21.8513,21.8513,0,0,0,12.841-7.085c4.26-5.031,4.656-10.721,4.871-14.612.808-14.6319-7.827-26.099-11.513-30.9939-2.837-3.7691-6.614-7.5311-14.169-15.055-4.182-4.1651-7.741-7.4991-10.184-9.7411q-30.441,5.2022-60.882,10.405",
    transform: "translate(-147.7442 -450.2613)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1074,488.0127l13.283,11.512q9.52-1.3275,19.04-2.657-1.218-6.7515-2.435-13.504-14.9445,2.3235-29.888,4.649",
    transform: "translate(-147.7442 -450.2613)",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnc);
export default __webpack_public_path__ + "static/media/enc.ecbcbf3f929732e4cab63367ab7f0fb6.svg";
export { ForwardRef as ReactComponent };